import React, { useState, useEffect } from "react";
import "./Phone.css";

const Phone = () => {
  const [time, setTime] = useState("");
  const [date, setDate] = useState("");
  const [isMenuActive, setIsMenuActive] = useState(false);
  const [inputValue, setInputValue] = useState(0);

  const months = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ];

  useEffect(() => {
    const timer = setInterval(() => {
      const now = new Date();
      const timeString =
        addLeadingZero(now.getHours()) + ":" + addLeadingZero(now.getMinutes());
      const dateString =
        now.getDate() + " " + months[now.getMonth()] + ", " + now.getFullYear();
      setTime(timeString);
      setDate(dateString);
    }, 1000);

    return () => clearInterval(timer);
  }, []);

  const addLeadingZero = (number) => {
    return number < 10 ? "0" + number : number;
  };

  const handleInputValueChange = (event) => {
    const value = parseInt(event.target.value);
    setInputValue(value);
    if (value === 100) {
      setIsMenuActive(true);
    } else {
      setIsMenuActive(false);
    }
  };

  const closeMenu = () => {
    setIsMenuActive(false);
    setInputValue(0);
  };

  return (
    <>
      <div className="outter-container">
        <div className="scrennn">
          <div className="box">
            <div className="boxheader">
              <i className="fa fa-brands fa-bluetooth-b"></i>
              <i className="fa fa-wifi"></i>
              <i className="fa fa-solid fa-battery-full"></i>
            </div>
            <div className="time-date">
              <h1>{time}</h1>
              <p>{date}</p>
            </div>
          </div>
          <div className="labelll" htmlFor="input">Swipe to Unlock</div>
          <input
            type="range"
            value={inputValue}
            onChange={handleInputValueChange}
          />
          <a
            className="aa"
            href="https://bhaskaracharjee.vercel.app/"
            target="_blank"
          >
            Bhaskar Acharjee
          </a>
        </div>

        <div className={`menu ${isMenuActive ? "active" : ""}`}>
          <div className="menuheader">
            <i className="fa fa-brands fa-bluetooth-b"></i>
            <i className="fa fa-wifi"></i>
            <i className="fa fa-solid fa-battery-full"></i>
          </div>
          <AppIcons />
          <div className="close" onClick={closeMenu}></div>
        </div>
      </div>
    </>
  );
};

const AppIcons = () => (
  <div className="apps">
    <a href="#">
      <i className="fa fa-regular fa-calendar"></i>
    </a>
    <a href="#">
      <i className="fa fa-brands fa-chrome"></i>
    </a>
    <a href="#">
      <i className="fa fa-solid fa-calculator"></i>
    </a>
    <a href="https://youtube.com/@CorvasBhaskar">
      <i className="fa fa-brands fa-youtube"></i>
    </a>
    <a href="https://www.facebook.com/bhaSkar.acharya.143">
      <i className="fa fa-brands fa-facebook"></i>
    </a>
    <a href="https://twitter.com/_bha_s_kar_">
      <i className="fa fa-brands fa-twitter"></i>
    </a>
    <a href="#">
      <i className="fa fa-solid fa-globe"></i>
    </a>
    <a href="https://www.instagram.com/bhassssskar/">
      <i className="fa fa-brands fa-instagram"></i>
    </a>
    <a href="tel:6290594650">
      <i className="fa fa-brands fa-whatsapp"></i>
    </a>
    <a href="mailto:bhaskaracharjee.world@gmail.com">
      <i className="fa fa-solid fa-envelope"></i>
    </a>
    <a href="#">
      <i className="fa fa-solid fa-address-book"></i>
    </a>
    <a href="tel:6290594650">
      <i className="fa fa-solid fa-phone"></i>
    </a>
    <a href="#">
      <i className="fa fa-solid fa-camera"></i>
    </a>
    <a href="#">
      <i className="fa fa-solid fa-gear"></i>
    </a>
    <a href="#">
      <i className="fa fa-brands fa-spotify"></i>
    </a>
    <a href="#">
      <i className="fa fa-solid fa-cloud"></i>
    </a>
  </div>
);

export default Phone;
